<app-field-container [field]="this">
  <div class="position-relative">
    <input [type]="inputType()" class="form-control"
           [formControl]="control"
           [placeholder]="placeholder() ?? ''"
           [maxlength]="maxLength()"
           [readonly]="readonly()"/>
    <button type="button" class="btn btn-link toggle-show" (click)="toggleShowPassword()">
      <lucide-icon [img]="showPassword() ? icons.hide : icons.show"></lucide-icon>
    </button>
  </div>
  <app-chars-left
    [maxLength]="maxLength()"
    [charsLeft]="charsLeft()"
    [charsLeftThreshold]="charsLeftThreshold()">
  </app-chars-left>
  @if (isBadCredentials()) {
    <div class="invalid-feedback d-block" *transloco="let t">
      {{ t('form.error.BadCredentials') }}
    </div>
  }
</app-field-container>


